// extracted by mini-css-extract-plugin
export var star = "SparkStar-module--star--8a024";
export var starPulse = "SparkStar-module--starPulse--16f6a";